<template>
    <LayoutDefault>
        <Feeds/>
    </LayoutDefault>
</template>

<script>
import LayoutDefault from "../layouts/LayoutDefault";
import Feeds from "../components/Sections/Feeds";

export default {
    components: {
        Feeds,
        LayoutDefault,
    },
}
</script>
